import { render, staticRenderFns } from "./RNakladnoy.vue?vue&type=template&id=ed4c90d6&scoped=true&"
import script from "./RNakladnoy.vue?vue&type=script&lang=js&"
export * from "./RNakladnoy.vue?vue&type=script&lang=js&"
import style0 from "./RNakladnoy.vue?vue&type=style&index=0&id=ed4c90d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4c90d6",
  null
  
)

export default component.exports